export default __webpack_public_path__ + "static/media/KumbhSans-Medium.1865f697.ttf";